// Ícone de categoria via sprite SVG (public/category-icons.svg, gerado por
// scripts/build-category-icons.mjs a partir do @phosphor-icons/core, peso bold).
// Os nomes são os mesmos que o app grava em categories.icon (finapp/lib/icons.ts).
// Um <use> por ícone: zero JS, um arquivo cacheado em vez de ~500 KB de componentes.

const SPRITE = '/category-icons.svg';

interface Props {
  name: string | null | undefined;
  size?: number;
  className?: string;
}

export function CategoryIcon({ name, size = 16, className }: Props) {
  const id = name && /^[a-z0-9-]+$/.test(name) ? name : 'tag';
  return (
    <svg width={size} height={size} className={className} aria-hidden="true" fill="currentColor">
      <use href={`${SPRITE}#${id}`} />
    </svg>
  );
}
